import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  header: css`
    display: flex;
    padding: 20px 16px 15px 16px;
    flex-direction: column;
  `,
  container: css`
    display: flex;
    padding: 32px 16px 0px 16px;
    flex-direction: column;
  `,
  userInfo: css`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  `,
};

export default styles;
